import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import AsyncComponentErrorHandler from 'framework-asset-preview-lib/internal/shared/components/AsyncComponentErrorHandler';
const AsyncWhatsAppTemplateImagePreview = Loadable({
  loader: () => import( /* webpackChunkName: "whatsapp-template-image-preview" */'./Preview/WhatsAppTemplateImagePreview').then(mod => mod.default).catch(AsyncComponentErrorHandler('whatsapp-image-preview')),
  LoadingComponent: () => null
});
export default AsyncWhatsAppTemplateImagePreview;